
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { defineComponent, ref, onMounted } from 'vue'
import { UserService } from './services/user.service'
import { CookieService } from './services/cookie.service';
import { openWxLogin } from '@/services/wechat/wxOauth.service'
import { getUrlParam } from '@shared/utils/base'

export default defineComponent({
  setup() {
    const isShowDom = ref(false)
    const injector = useReflectiveInjector([CookieService, UserService])
    const userService = injector.get(UserService)
    const cookieService = injector.get(CookieService)
    onMounted(() => {
      const userInfo = cookieService.getUserInfo()
      const code = getUrlParam('code')
      if (userInfo) {
        userService.updateUserinfo(userInfo)
        isShowDom.value = true
      } else if (code) {
        userService.updateUserinfoByCode(code).finally(() => {
          isShowDom.value = true
        })
      } else {
        openWxLogin()
      }
    })
    return {
      isShowDom
    }
  },
})
